import React, { useEffect } from "react";
import { FetchProducts } from "../Actions/productAction";
import { useDispatch, useSelector } from "react-redux";
import ProductCards from "../components/ProductCards/index";
import Load from "../components/Loading/index";

export default function Product() {
    const dispatch = useDispatch();
    const { Product, Loading } = useSelector((state) => state.product);

    useEffect(() => {
        dispatch(FetchProducts());
    }, []);

    return (
        <>
            {!Loading ? (
                <ProductCards text={"Products"} product={Product}></ProductCards>
            ) : (
                <Load text={"Loading Products"} />
            )}
        </>
    );
}
